export const projects = [
  {
    id: "ai-job-engine",
    name: "AI Job Application Engine",
    highlight: true,
    description: [
      "Fully automated job application tool — apply to 50 jobs in 10 minutes with a tailored resume for each",
      "Auto-scans fresh HR job posts from the internet (last 24h, 48h, or 1 week) based on target role",
      "AI reads job descriptions, finds skill gaps, and rewrites your resume to match — powered by Grok AI API",
      "Extracts recruiter emails and sends personalized outreach with customized resume attached",
      "Reduces 3–4 hours of daily manual work to under 5 minutes"
    ],
    techStack: ["React.js", "Node.js", "Grok AI API", "Kiro"],
    impact: "Built using Kiro — entire backend and API integration delivered in a fraction of usual time",
    liveUrl: null,
    githubUrl: null,
    featured: true
  },
  {
    id: "data-mesh",
    name: "Data Mesh Platform",
    description: [
      "Enterprise platform for migrating business data from legacy on-premise ERP to modern cloud systems",
      "Handles data cleansing, transformation, mastering, governance, and large-scale migration execution",
      "Clients define conditional business rules applied automatically across millions of records",
      "Handles enterprise-level datasets, used by Fortune 500 clients across multiple countries"
    ],
    techStack: ["React.js", "TypeScript", "Redux", "React Flow", "Single-SPA", "MUI", "Module Federation", "Jest", "RTL", "Socket.io"],
    impact: "Built features using Claude AI — automated workflows and frontend architecture accelerated with AI",
    liveUrl: "https://projects.albanero.io/login",
    githubUrl: null,
    featured: true
  },
  {
    id: "dsa-whiteboard",
    name: "DSA Whiteboard",
    description: [
      "Digital whiteboard for explaining data structures, algorithms, and system design in technical interviews",
      "Supports freehand drawing, arrays, trees, graphs, arrows, and text annotations",
      "Undo/Redo, color palette, stroke thickness control, and highlighter",
      "Single HTML file — no frameworks, no installation, no build step. Works on desktop and tablet"
    ],
    techStack: ["Vanilla JS", "HTML5 Canvas", "CSS3"],
    impact: "Built using Amazon Q — zero-dependency canvas logic built with AI pair programming",
    liveUrl: "https://rainbow-speculoos-13ef6a.netlify.app/",
    githubUrl: null,
    featured: true
  },
  {
    id: "trendy-shop",
    name: "Trendy Shop",
    description: [
      "Full-stack e-commerce platform similar to Amazon — browse, cart, checkout, and secure payments",
      "Product listings with search, filters by category/price, and detailed product pages",
      "JWT authentication, order history, and user profile management",
      "Admin dashboard for inventory management, order tracking, and stock updates",
      "Fully responsive across mobile, tablet, and desktop"
    ],
    techStack: ["React.js", "Redux", "Node.js", "Express.js", "MongoDB", "Chart.js", "JWT"],
    impact: "Built with ChatGPT — component structure and API design speed-developed with AI",
    liveUrl: "https://trendyshops.vercel.app/",
    githubUrl: "https://github.com/Shoaib20-1998/Trendyshop",
    featured: true
  },
  {
    id: "medz-plus",
    name: "MedZ+",
    description: [
      "Online healthcare store similar to Tata 1mg — order medicines, supplements, and test kits",
      "Prescription medicines, OTC drugs, vitamins, and diagnostic kits — searchable and categorized",
      "Secure authentication, encrypted transactions, and order tracking",
      "Designed for users of all ages including elderly with simple, easy-to-navigate interfaces"
    ],
    techStack: ["React.js", "JavaScript", "TypeScript", "Redux", "Chakra UI", "Chart.js"],
    impact: "Built with ChatGPT — backend API routes and database schema designed with AI",
    liveUrl: "https://medzplus.vercel.app/",
    githubUrl: "https://github.com/Shoaib20-1998/MedZ",
    featured: true
  },
  {
    id: "be-stylish",
    name: "Be Stylish",
    description: [
      "Online fashion store similar to Myntra — clothing and accessories for men, women, and kids",
      "Product search, category filters, size selection, wishlist, cart, and secure checkout",
      "Clean, visually rich UI designed to feel like a real retail experience",
      "Optimized for mobile shoppers who make up the majority of fashion buyers in India"
    ],
    techStack: ["React.js", "JavaScript", "TypeScript", "Chakra UI", "Sweet Alert"],
    impact: "Built with ChatGPT — UI components and Redux state management accelerated with AI",
    liveUrl: "https://bestylish.vercel.app/",
    githubUrl: "https://github.com/Shoaib20-1998/Be-Stylish",
    featured: true
  },
  {
    id: "gadgets-plus",
    name: "Gadgets++",
    description: [
      "Tech news and product review site similar to Gadgets 360 — helping consumers make informed decisions",
      "Honest product reviews, spec comparisons, and buying guides for mobiles, laptops, and wearables",
      "Category-wise browsing, search by brand/model, and clean reading experience"
    ],
    techStack: ["HTML", "CSS", "JavaScript"],
    impact: "Built with ChatGPT — content structure and search functionality developed with AI",
    liveUrl: "https://gadgets-rho.vercel.app/",
    githubUrl: "https://github.com/Shoaib20-1998/Gadgets",
    featured: false
  },
  {
    id: "beautify",
    name: "Beautify",
    description: [
      "Online beauty store similar to Nykaa — cosmetics, skincare, haircare, and personal care products",
      "Browse by brand, category, skin type, or price range with detailed product pages",
      "User login, wishlist, shopping cart, order placement, and order history",
      "Mobile-first design since majority of beauty shoppers browse on phones"
    ],
    techStack: ["HTML", "CSS/SCSS", "JavaScript", "TypeScript"],
    impact: "Built with ChatGPT — product filtering logic and UI layout developed with AI",
    liveUrl: "https://beautiffy.netlify.app/",
    githubUrl: "https://github.com/Shoaib20-1998/Beautify",
    featured: false
  },
  {
    id: "digi-amigo",
    name: "Digi Amigo",
    description: [
      "Digital services platform connecting SMBs with web development and marketing experts",
      "Services: web development, social media management, Google Ads, and performance marketing",
      "Service listings, expert profiles, contact forms — designed for non-tech-savvy business owners",
      "Helps brands establish digital presence, run targeted campaigns, and increase online engagement"
    ],
    techStack: ["HTML", "CSS/SCSS", "JavaScript", "TypeScript"],
    impact: "Built with ChatGPT — service listing pages and contact flow developed with AI",
    liveUrl: "https://digiamigos.com/",
    githubUrl: null,
    featured: true
  }
];
